module.exports = __webpack_public_path__ + "static/img/logo-full.368d7bd6.svg";